import React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const DraggableArea = ({ items, setItems, droppableId, draggableContent }) => {
    const renderItems = () => {
        return (
            draggableContent &&
            draggableContent.map((item, index) => {
                return (
                    <Draggable
                        key={index}
                        draggableId={`${index}`}
                        index={index}
                    >
                        {(provided) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                            >
                                {item}
                            </div>
                        )}
                    </Draggable>
                );
            })
        );
    };

    const handleOnDragEnd = (result) => {
        if (result.destination) {
            const newItems = [...items];
            const temp = newItems[result.source.index];
            newItems[result.source.index] = newItems[result.destination.index];
            newItems[result.destination.index] = temp;
            setItems(newItems);
        }
    };

    return (
        <>
            <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId={droppableId}>
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {renderItems()}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </>
    );
};
export default DraggableArea;
